module.exports = __webpack_public_path__ + "static/media/beltran.53d72225.jpg";